import React from 'react'
import { useTVL } from '../hooks/useTVL'

function Tvl({ contractAddress, poolType, tokenAddress }) {
  const { tvl, rawTvl, tvlUSD, loading, error } = useTVL(contractAddress, poolType, tokenAddress)
  // console.log(tvl, tvlUSD, error, poolType, 'tvl, loading, error');
  // React.useEffect(() => {
  //   if (rawTvl && setTvlAmount) {
  //     setTvlAmount(rawTvl)
  //   }
  // }, [tvl, setTvlAmount])
  return (
    <>{tvlUSD ? "$"+ Number(parseFloat(tvlUSD).toFixed(4)).toLocaleString() : Number(parseFloat(tvl).toFixed(4)).toLocaleString()}</>
  )
}

export default Tvl